<page-title [title]="title"></page-title>
<p *ngIf="currentUser.type != 'patient'">Aqui você pode consultar e gerenciar os seus atendimentos.</p>
<p *ngIf="currentUser.type == 'patient'">Aqui você pode consultar e gerenciar as suas consultas.</p>
<form class="row">
  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Especialista/Exame</mat-label>
      <mat-select [(value)]="tipoSchedule">
        <mat-option *ngFor="let item of filterTipos; let i = index" [value]="i">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-xs-12 col-md-9">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Buscar agendamento</mat-label>
      <input
        type="text"
        matInput
        [(ngModel)]="buscarSchedule"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Digite aqui os detalhes do agendamento (tipo de serviço; paciente; data)"
      />
    </mat-form-field>
  </div>
  <!-- <div class="col-xs-12 col-md-3">
        <button mat-flat-button color="primary" (click)="pesquisar()" [disabled]="loading" >Buscar</button>
    </div>     -->
</form>
<mat-tab-group>
  <mat-tab *ngFor="let tab of tabs" [label]="tab.title">
    <div class="col-xs-12" *ngFor="let schedule of getContent(tab.id)">
      <mat-card>
        <div class="col-md-12">
          <h3>
            {{ layout.dateTimeFormat(schedule.dateStart) }} - {{ schedule.type }}
            <mat-chip color="accent" class="float-right" [ngClass]="getColorStatus(schedule.status)">
              {{ getTextStatus(schedule.status) }}
            </mat-chip>
          </h3>
        </div>
        <div class="col-xs-12 col-md-8">
          <div class="content" *ngIf="schedule.type == 'Consulta'">
            <div *ngIf="currentUser.type != 'practitioner'">Especialista: {{ schedule.practioner?.name }}</div>
            <div *ngIf="currentUser.type == 'patient' && schedule.practioner?.specialty">Especialidade: {{ schedule.practioner?.specialty }}</div>
          </div>
          <div class="content">
            Paciente: {{ schedule.patient.name }} <br />
            <div *ngIf="schedule.organization">Instituição: {{ getOrganizationName(schedule.organization) }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="actions">
            <button mat-button (click)="openComponentDialogScheduleEditStatusForm(schedule)" color="primary" *ngIf="currentUser.type != 'patient'">
              Alterar status
            </button>
            <button mat-flat-button color="primary" (click)="openComponentDialogScheduleDetailForm(schedule)" [disabled]="loading">
              Ver detalhes
            </button>
          </div>
        </div>
      </mat-card>
    </div>
    <button mat-button color="primary" (click)="loadMore()" *ngIf="atendimentosFiltro.length > registrosExibidos">Ver mais</button>
  </mat-tab>
</mat-tab-group>
